import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PointReminderModalService } from '../../points/point-reminders/point-reminder-modal/point-reminder-modal.service';
import { TReminder } from '../../reminders/reminders.consts';

@Component({
    selector: 'pp-reminder-alert',
    templateUrl: './reminder-alert.component.html',
    styleUrl: './reminder-alert.component.scss',
    standalone: false
})
export class ReminderAlertComponent {
  @Input() ppReminder: TReminder;
  @Input() ppHighlighted: boolean;
  @Output() ppSelect = new EventEmitter<void>();

  constructor(private pointReminderModalService: PointReminderModalService) {}

  selectReminder(): void {
    this.ppSelect.emit();
  }

  openReminderModal(): void {
    this.pointReminderModalService.showReminderModal({
      reminder: this.ppReminder,
    });
  }
}
